export const initialStackBarGraphState = {
	labels: [],
	datasets: [],
};

export const initialStackBarGraphNumberFormat = {
	postfix: '',
	divider: 1,
};
